export enum TrusteeType {
  none = 0,
  user = 1,
  group = 2
}
